import React, {useState} from "react";
import "../../assets/styles/tabs.css";
import CustomizedSteppers from "../../components/Stepper/CustomizedSteppers";
import UsageDataForm from "../../components/Form/UsageDataForm";
import BeneficiaryDataLoader from "../../components/BeneficiaryDataLoader/BeneficiaryDataLoader";
import EntryData from "../../components/EntryData/EntryData";

const componentsMap = {
  "Dados utilização operadora": <UsageDataForm />,

  "Dados dos beneficiarios": <BeneficiaryDataLoader />,

  "Dados Especialidades Médicas Ambulatoriais": (
    <EntryData
      key="medicalSpecialties"
      initialHeader="Dados Especialidades Médicas Ambulatoriais"
      cacheName="medicalSpecialties"
      helperFileName={"especialidades_medicas"}
      instruction={`
        <p>Totalize o número de <strong>médicos que prestam atendimento AMBULATORIAL</strong> em cada especialidade no município.</p>
        <p>Se uma clínica tiver mais de um médico na mesma especialidade, <strong>some o total de profissionais dessa especialidade</strong> em cada clínica no município.</p>
        <br />
        <p>Caso não tenha o total de médicos da mesma especialidade em cada clínica, <strong>conte o número de clínicas</strong> com a especialidade médica.</p>
        <br />
        <h3><strong>FAQ – fator de ajuste da Operadora:</strong></h3>
        <p><strong>Campo FAQ:</strong> O percentual de médicos de cada especialidade deve refletir a quantidade de especialistas <strong>destinada à sua operadora.</strong> Para calcular essa fração, utilize o exemplo a seguir:</p>
        <br />
        <p><strong>Exemplo:</strong></p>
        <ul>
          <li>• Se 15 médicos são compartilhados com 30 outras Operadoras:</li>
          <li>• Divida o número total de médicos (15) pelo número total de operadoras (30): <code>15 / 30 = 0,5</code></li>
          <li>• Para obter o fator de ajuste (porcentagem), multiplique por 100: <code>0,5 * 100 = <strong>50%</strong></code></li>
          <li>• A operadora poderá usar um fator de ajuste padrão (único) para cada município e aplicá-lo em todas as especialidades.</li>
        </ul>
      `}
    />
  ),

  "Profissionais Não Médicos Ambulatoriais": (
    <EntryData
      key="nonMedicalSpecialties"
      initialHeader="Profissionais Não Médicos Ambulatoriais"
      cacheName="nonMedicalSpecialties"
      helperFileName={"especialidades_nao_medicas"}
      instruction={
        `
          <p style="margin-top: 0.25rem;">1. Totalize o número de profissionais não médicos que prestam atendimento AMBULATORIAL por tipo de profissional.</p>
          <p style="margin-top: 0.25rem;">2. Se uma clínica tiver mais de um profissional, some o total de profissionais em cada clínica.</p>
        
          <h3 style="margin-top: 1rem; color: #1e3a8a; font-weight: bold;">Outros profissionais não médicos:</h3>
          <p style="margin-top: 0.25rem;">1. Totalize o número de profissionais não médicos que prestam atendimento AMBULATORIAL que não constem na listagem.</p>
          <p style="margin-top: 0.25rem;">2. Se uma clínica tiver mais de um profissional, some o total de profissionais em cada clínica.</p>
        
          <h3 style="margin-top: 1rem; color: #1e3a8a; font-weight: bold;">% Serviços para OPS:</h3>
          <p style="margin-top: 0.25rem;">1. Coluna % disponível para Operadora: o percentual de serviços/equipamentos deve refletir a quantidade de serviços ou equipamentos destinada à sua operadora. Para calcular essa fração, use o exemplo:</p>
          <p style="margin-top: 0.25rem;">Se 10 clínicas ou 10 equipamentos são compartilhados com 40 outras operadoras:</p>
          <p style="margin-top: 0.25rem;">Divida o número total de clínicas ou equipamentos (10) pelo número total de operadoras (40): 10 / 40 = 0,25</p>
          <p style="margin-top: 0.25rem;">Para obter a porcentagem, multiplique por 100: 0,25 * 100 = 25%</p>
        `
      }
    />
  ),

  "Dados Procedimentos ambulatoriais": (
    <EntryData
      key="procedureOutpatient"
      initialHeader="Dados Procedimentos ambulatoriais"
      cacheName="procedureOutpatient"
      helperFileName={"procedimentos_ambulatoriais"}
      instruction="Preencha a quantidade de procedimentos ambulatoriais realizados em cada cidade. Utilize dados da produção ambulatorial ou registros internos."
    />
  ),

  "Serviços de Apoio Diagnóstico e Terapias Ambulatoriais": (
    <EntryData
      key="examOutpatient"
      initialHeader="Serviços de Apoio Diagnóstico e Terapias Ambulatoriais"
      cacheName="examOutpatient"
      helperFileName={"exames_ambulatoriais"}
      instruction="Informe a quantidade de exames ambulatoriais realizados por cidade, conforme disponibilidade da rede e dados anteriores de utilização."
    />
  ),



  "Serviços de urgência e emergência": (
    <EntryData
      key="urgencyAndEmergency"
      initialHeader="Serviços de urgência e emergência"
      cacheName="urgencyAndEmergency"
      helperFileName={"urgencia_emergencia"}
      instruction="Nesta etapa, registre os atendimentos de urgência e emergência disponíveis em cada cidade. Leve em conta unidades de pronto atendimento, hospitais e prontos-socorros conveniados."
    />
  ),

  "Hospitais": (
    <EntryData
      key="hospital"
      initialHeader="Hospitais"
      cacheName="hospital"
      helperFileName={"hospitais"}
      instruction="Indique a quantidade de hospitais disponíveis em cada cidade da rede credenciada. Utilize como base os estabelecimentos que realizam atendimentos hospitalares."
    />
  ),

  "Leitos Hospitalares": (
    <EntryData
      key="hospitalBeds"
      initialHeader="Leitos Hospitalares"
      cacheName="hospitalBeds"
      helperFileName={"leitos"}
      instruction="Informe a quantidade de leitos hospitalares disponíveis por cidade. Considere leitos clínicos, cirúrgicos e outros disponíveis na rede credenciada."
    />
  ),

  "Dias de internação": (
    <EntryData
      key="hospitalizationDays"
      initialHeader="Dias de internação"
      cacheName="hospitalizationDays"
      helperFileName={"dias_internacao"}
      optional={true}
      instruction="Registre a média de dias de internação por cidade. Esta etapa é opcional, mas recomendada para melhor dimensionamento da demanda hospitalar."
    />
  ),
};

const transformToNavigation = (steps) => {
  return steps.map(({ stepName, completed, unlocked }) => {
    const navItem = {
      stepName,
      completed,
      unlocked,
    };

    if (componentsMap[stepName]?.props?.optional) {
      navItem.optional = true;
    }

    if ((unlocked || navItem.optional) && componentsMap[stepName]) {
      navItem.direct = componentsMap[stepName];
    }
    return navItem;
  });
};

const GettingData = () => {
  const [navigation, setNavigation] = useState([]);
  const [activeStep, setActiveStep] = useState(0);

  return (
    <div className="md:px-8 px-4 mt-4  w-full overflow-hidden bg-[#fff] flex flex-col text-secondary max-h-[95vh]">
      <div className="w-full pl-4 md:pl-0">
        <CustomizedSteppers
          navigation={navigation}
          activeStep={activeStep}
          setNavigation={setNavigation}
          setActiveStep={setActiveStep}
        />
      </div>
      <div className="tab-content h-inherit flex justify-center overflow-hidden">
        {navigation[activeStep]?.direct || <div>Selecione uma etapa disponível.</div>}
      </div>
    </div>
  );
};

export default GettingData;
export { transformToNavigation };
